export default __webpack_public_path__ + "static/media/sleuthofbears.a4449873.png";